export default __webpack_public_path__ + "static/media/aboutSam.46ad91f1.JPG";